import React from "react";
import { Box } from "@mui/material";
import { IntrinsicValueCard } from "./IntrinsicValueCard";
import { PriceTargetChart } from "./PriceTargetChart";
import { AnalystGradesChart } from "./AnalystGradesChart";
import { AnalystEstimatesCard } from "./AnalystEstimatesCard";

interface ValuationTabProps {
  ticker: string;
}

export const ValuationTab: React.FC<ValuationTabProps> = ({ ticker }) => {
  return (
    <Box>
      {/* Intrinsic Value & Analyst Grades Row */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "1fr 1fr",
          },
          gap: 2,
          mb: 3,
        }}
      >
        {/* Intrinsic Value Card */}
        <IntrinsicValueCard ticker={ticker} />

        {/* Analyst Grades Chart */}
        <AnalystGradesChart ticker={ticker} />
      </Box>

      {/* Price Target Chart - Full Width */}
      <Box sx={{ mb: 3 }}>
        <PriceTargetChart ticker={ticker} />
      </Box>

      <AnalystEstimatesCard ticker={ticker} />
    </Box>
  );
};

export default ValuationTab;
